// oxlint-disable-next-line typescript/no-require-imports
export const faviconPath: string = require('@ms/yammer-assets/dist/web/ve/favicon.ico');
// oxlint-disable-next-line typescript/no-require-imports
export const faviconDotPath: string = require('@ms/yammer-assets/dist/web/ve/faviconDot.ico');
